'use client'

import PropTypes from 'prop-types'
import { WizardPanel } from '@repo/ui/WizardPanel'
import { WizardFormSection } from '@repo/ui/WizardFormSection'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'
import { LargeCalendarIcon } from '@repo/ui/LargeCalendarIcon'
import MUIStack from '@mui/material/Stack'
import { DateSelection } from '@repo/ui/DateSelection'
import { ReviewTypeSelect } from '@repo/ui/ReviewTypeSelect'
import { TextEntry } from '@repo/ui/TextEntry'

export const NewMatterReview = ({ updateStepState, wideMode, handlePrevNext, testData }) => {
  const { reviewDate, reviewType, reviewPeriod, updateState } = useNewMatterStore()

  const handleClickContinue = () => {
    updateStepState({ status: 'completed', statusText: 'Complete' })
    handlePrevNext(1)
  }

  const handleClickBack = () => {
    handlePrevNext(-1)
  }

  return (
    <>
      <WizardPanel data-testid="NewMatterReview">
        <WizardFormSection>
          <WizardIconTitle title="Review" icon={LargeCalendarIcon} sx={{ mb: 8 }} isOptional />

          <MUIStack gap={4} direction="row" alignItems="center" flexWrap={'wrap'} sx={{ width: '100%' }}>
            <DateSelection
              format="d MMM yyyy"
              value={reviewDate ? new Date(reviewDate) : null}
              onChange={(value) => updateState({ key: 'reviewDate', value })}
              size="medium"
              label="Review date"
              sx={{ width: '100%', maxWidth: '478px' }}
              enableTypedDdMmYyyy={true}
              showAdornment={true}
              largeAdornment={true}
            />

            <ReviewTypeSelect
              value={reviewType}
              onChange={(value) => updateState({ key: 'reviewType', value })}
              size="medium"
              sx={{ width: '100%', maxWidth: '478px' }}
              testData={testData}
            />

            <TextEntry
              size="medium"
              value={reviewPeriod}
              onChange={(value) => updateState({ key: 'reviewPeriod', value })}
              label="Review period"
              isNumber
              endAdornment="days"
              sx={{ width: '100%', maxWidth: '478px' }}
              min={0}
            />
          </MUIStack>
        </WizardFormSection>
      </WizardPanel>
      <WizardFooter wideMode={wideMode} handleClickContinue={handleClickContinue} handleClickBack={handleClickBack} />
    </>
  )
}

NewMatterReview.propTypes = {
  updateStepState: PropTypes.func,
  currentStep: PropTypes.object,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  testData: PropTypes.array
}
